import { render, staticRenderFns } from "./CoePublishedResult.vue?vue&type=template&id=01b70536"
import script from "./CoePublishedResult.vue?vue&type=script&lang=js"
export * from "./CoePublishedResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports